import React, { useEffect, useState } from 'react';
import Status from '../../../core/types/Status';
import Modal from '../../../core/components/Modal/Modal';
import { DataTableHeader } from '../../../core/components/Table/types/DataTableHeader';
// @ts-ignore
import styles from './PayAllTile.module.scss';
import { PayCasesVM } from './types/PayCasesVM';
import { PayCaseVM } from './types/PayCaseVM';
import { PayableItem } from './types/PayableItem';
import { InfoMessageService, TranslationService } from '../../../core/services';
import { Alert, Button, Loader, ModuleContainer, Table } from '../../../core/components';
import ApiProvider from '../../../core/api/ApiProvider';

type Props = {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  onPayCase: (payCase: PayableItem) => void;
};

const CasesModal = (props: Props) => {
  const { isOpen, onToggle } = props;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [model, setModel] = useState<PayCasesVM>({} as PayCasesVM);

  const fetchData = async () => {
    try {
      const data = await getPayAllCases();
      setModel(data.data);
      if (!data.success) {
        InfoMessageService.error(data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getPayAllCases = async () => {
    return await ApiProvider.get<Status<PayCasesVM>>('PayAllTileModule/GetPayAllCases');
  };

  const tableHeaders: DataTableHeader[] = [
    {
      headerName: TranslationService.translate('Case'),
      columnName: 'caseNo',
      isVisible: true,
    },
    {
      headerName: TranslationService.translate('BalanceToPay'),
      columnName: 'balanceAmount',
      cssClassNames: '',
      isVisible: true,
      formatter: (value: any, row: PayCaseVM) => (
        <>
          {row.balanceAmount} <em className="currency-symbol">{row.currency}</em>
        </>
      ),
    },
    {
      headerName: '',
      columnName: 'actions',
      cssClassNames: '',
      isVisible: true,
      formatter: (value: any, row: PayCaseVM) => {
        return (
          <Button
            variant={Button.Variants.Primary}
            type={Button.Types.Button}
            onClick={() =>
              props.onPayCase({
                caseNo: row.caseNo,
                caseGuid: row.caseGuid,
                sourceTenantId: row.sourceTenantId,
                itemType: 0,
              })
            }
          >
            {TranslationService.translate('PayNow')}
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onToggle={onToggle}
        className={styles.modalWrapper}
        closeBtnClass="modal-close-btn"
      >
        <ModuleContainer classNames="mt-0 mb-0" variant={ModuleContainer.ModuleVariant.Variant1}>
          <ModuleContainer.Header title={TranslationService.translate('ChooseCase')} />
          <ModuleContainer.Body variant={ModuleContainer.Body.BodyVariant.Primary}>
            {isLoading && <Loader opacity={0.4} />}
            {model.payCases && model.payCases.length > 0 ? (
              <Table
                headers={tableHeaders}
                rows={model.payCases}
                keyField="caseGuid"
                paginationProps={{
                  hideSizePerPage: true,
                  hidePageListOnlyOnePage: true,
                }}
              />
            ) : (
              !isLoading && (
                <Alert variant={Alert.Variants.Info}>
                  {TranslationService.translate('PayAllTile_NothingToPay')}
                </Alert>
              )
            )}
          </ModuleContainer.Body>
        </ModuleContainer>
      </Modal>
    </>
  );
};

export default CasesModal;
